export default __webpack_public_path__ + "static/media/PlusActive.6cd512b4.svg";